var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "check-container",
      class: _vm.statue ? "check-disable" : "",
      on: { click: _vm.handleClick }
    },
    [
      _c(
        "div",
        {
          staticClass: "check-icon-sty-wrap",
          class: _vm.flag == 1 ? "backg-wh" : ""
        },
        [
          _c("i", {
            staticClass: "check-icon-sty",
            class:
              _vm.flag == 1
                ? "no-select"
                : _vm.flag == 2
                ? "el-icon-check"
                : "el-icon-minus"
          })
        ]
      ),
      _c("div", { staticClass: "label" }, [_vm._t("default")], 2)
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }